import type { ModalProps as ChakraModalProps } from '@chakra-ui/react';
import { Modal as ChakraModal } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';

export interface ModalProps
  extends OmitChakraProps<
    ChakraModalProps,
    'styleConfig' | 'variant' | 'styleConfig' | 'orientation'
  > {
  // Unfortunately these props get caught up in ChakraProps so we need to add them
  // back in manually
  scrollBehavior?: ChakraModalProps['scrollBehavior'];
}

export const Modal = ({ isCentered = true, ...props }: ModalProps) => (
  <ChakraModal isCentered={isCentered} {...props} />
);
